import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';
import { spaceBetween } from '../styles/mixins';

export const useConfirmOrderPageStyles = createStyles(({ token }) => ({
  fullWidth: {
    width: '100%',

    '.SimpleCard-Header': {
      display: 'none',
    },
  },
  fullWidthDivider: {
    display: 'none',
  },
  combined: {
    padding: `${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_20}px`,
    height: 160,

    '> .ant-row': {
      height: '100%',
    },
  },
  quote: {
    height: 128,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  quoteLabel: {
    color: ThemeColors.COLOR_GREY_BLUISH2,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&.size-sm': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
    '&.size-lg': {
      fontSize: token.fontSizeHeading3,
    },
  },
  quoteValue: {
    color: token.colorPrimary,
    fontWeight: 500,
    lineHeight: 1,

    '&.size-sm': {
      fontSize: token.fontSizeHeading4,
    },
    '&.size-md': {
      fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
    },
    '&.size-lg': {
      fontSize: ThemeFont.FONT_SIZE_30,
      marginBottom: ThemeSpaces.SPACE_MD,
    },
  },
  main: {
    marginBottom: ThemeSpaces.SPACE_NORM,
  },
  innerContent: {
    [`@media (min-width: ${token.screenLGMin}px)`]: {
      '> *': {
        ...spaceBetween(ThemeSpaces.SPACE_NORM_20, 'vertical'),
      },
    },
  },
}));
